module.exports = __webpack_public_path__ + "static/img/planRight8.ec683d3b.png";